import axios from 'axios'
import router from '@/router'
import i18n from '@/plugins/i18n/i18n'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const actions = {
  authRequest (context, uri) {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login

      const currentLanguage = (i18n.locale == 'en-EN') || (i18n.locale == 'en') ? 'en' :
      (i18n.locale == 'fr-FR') || (i18n.locale == 'fr') ? 'fr' :
      (i18n.locale == 'nl-NL') || (i18n.locale == 'nl') ? 'nl' : 'fr'

      let alert = false
      let alertType = 'error'
      let alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']
      
      axios.get(randomBaseUrl(0, 3) + process.env.VUE_APP_LOGIN_ENDPOINT + uri)
        .then(response => {

          const status = response.data.status
          // Check status response
          if (status === 'error') {
            const subject = response.data.message

            switch (subject) {
              case 'Please validate your account first !':
                alertType = 'error'
                alertMessage = i18n.messages[currentLanguage]['auth-request']['validate-account']
                break

              case "User doesn't exists":
                alertType = 'error'
                alertMessage = i18n.messages[currentLanguage]['auth-request']['login-not-correct']
                break

              case 'Login too short':
                alertType = 'error'
                alertMessage = i18n.messages[currentLanguage]['auth-request']['login-shoort']
                break

              case 'Wrong password':
                alertType = 'error'
                alertMessage = i18n.messages[currentLanguage]['auth-request']['pswrd-not-correct']
                break
            }

            alert = true // show alert box

            localStorage.removeItem('user-token') // remove any possible user-token
            context.commit('authLogout')

          } else if (status === 'ok') {

            alert = false // remove a potential alert box
            // normally not showing info but we change it just in case
            alertType = 'success'
            alertMessage = i18n.messages[currentLanguage]['auth-request']['success']

            const token = response.data.answer.valid
            localStorage.setItem('user-token', token) // store the token
            context.commit('authSuccess', token)

          } else {
            // normaly impossible case with no error but no correct response
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']
            alert = true // show alert box

            localStorage.removeItem('user-token') // remove any possible user-token
            context.commit('authLogout')

          }
          resolve({response, status, alert, alertType, alertMessage})
        })
        .catch(() => {
          localStorage.removeItem('user-token') // if the request fails, remove any possible user-token if possible
          context.commit('authLogout')

          // error
          alertType = 'error'
          alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']
          alert = true // show alert box
          reject({alert, alertType, alertMessage})
        })

        return

    })
  },

  authLogout (context, options) {
    return new Promise(() => {
    
      if (context.rootState.auth.token) {
        const params = { // escape uri
          options: options && options.options ? encodeURIComponent(options.options) : 'json',
          key: encodeURIComponent(context.rootState.auth.token)
        }
        const uri = `?options=${params.options}&valid=${params.key}`

        axios.get(randomBaseUrl(0, 3) + process.env.VUE_APP_LOGOUT_ENDPOINT + uri)
          .then(() => {
            localStorage.removeItem('user-token') // clear your user's token
            context.commit('authLogout')
            // if (options && options.backToLogin) router.push('/')
            router.push('/')
          })
          .catch(() => {
            // if any error append's just force to logout any possible connected user's
            localStorage.removeItem('user-token') // clear your user's token
            context.commit('authLogout')
            // if (options && options.backToLogin) router.push('/')
            router.push('/')
          })

      } else {
        localStorage.removeItem('user-token') // clear any potential token
        context.commit('authLogout')
        router.push('/')
      }
    })
  }
}
